import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

import './../styles/product-options.css'

function ProductOptions({ title, options, productOption, setProductOption }) {
  return (
    <section className="product-options-container">
      <FormControl fullWidth className="car-model-form-control">
        {!!title && (
          <h5 className="product-options-title">{title}</h5>
        )}
        <Select
          id="product-options"
          value={productOption}
          onChange={(e) => setProductOption(e.target.value)}
          className="product-options-select"
        >
          {options.map(option => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </section>
  )
}

export default ProductOptions
